module.exports = __webpack_public_path__ + "static/img/zheng.24b2e3e2.png";